/**
 * p05001専用メソッド 
 */

// Vue
import router from '@/router';
// import { useRoute } from 'vue-router'; // 画面パラメーター取得用

// axios
import axios, { AxiosResponse } from "axios";

// メモった！、キニッタ！共通
import * as JC from '@/components/00/JsonContainer';    // 通信用Jsonコンテナ
import * as GVar from '@/components/00/Var00';          // 共通変数
import * as GFunc from '@/components/00/Common00';      // 共通メソッド
import * as Tools from '@/components/00/Tools';         // 共通ツール
import * as Mst004 from '@/components/00/db/Mst004';    // お気に入り情報
import * as Push from '@/components/00/Push';           // push通知用メソッド(Android, iOS)
import * as Push2 from '@/components/00/Push2';         // push通知用メソッド(PC)
import * as Mst002 from '@/components/00/db/Mst002';    // MST002

// キニッタ！専用
import * as LVar from '@/components/05/Var05001';                   // キニッタ！専用変数
import * as Const05 from '@/components/05/properties/Const05';
import * as Msg05Ja from '@/components/05/properties/Message05001_ja';
import * as DLink from '@/components/05/DynamicLink05001';   // ダイナミックリンク

/**
 * 画面表示などに使うツールを定義する
 */

//=================================================================
// 起動時スクリプト
//=================================================================

/**
 * 条件により初期画面を表示する
 */
export async function dispatch()
{
	if ( GFunc.isDebugEnabled() ) {console.log("dispatch()");}
    // 初期表示ページの設定
    await setStartPage();
	// 表示モードの初期化
	if ( GVar.mst002 == null )
	{
		//---------------------------
		// Mst002にログイン情報なし
		//---------------------------
		// ログインしないでキニッタ！を使用
		noLogin();
	}
	else
	{
		//---------------------------
		// Mst002にユーザー情報あり
		//---------------------------
		if ( GVar.mst002.eml == null || GVar.mst002.pwd == null )
		{
            // ログインしないでキニッタ！を使用
            noLogin();
		}
		else
		{
			if ( GFunc.isDebugEnabled() ) {console.log("auto login="+GVar.autoLogin);}
			// 自動ログインのチェック
			if ( GVar.autoLogin )
			{
				// サーバーから最新のユーザー情報を取得
				await getUserInfo(GVar.mst002.eml, GVar.mst002.pwd, GVar.autoLogin, GVar.langCd, GVar.ttype);
				if ( GFunc.getServerSttsCd() != getProperty("JSON.STATUS.OK")
						&& GFunc.getServerSttsCd() != null /* ネットワークエラーの時はServerSttsCdがnull */)
				{
					// ログイン失敗（ＩＤ又はパスワード違い）のためログインページを再表示
					alert(GFunc.getServerMsg());
                    noLogin();
				}
				else
				{
                    // ログイン成功
					// ネットワークエラーの時はsessionstorageにユーザー情報があるので
					// サーバー接続の可否にかかわらずマイページを表示

                    // ログイン後処理
                    afterLogin();
                    return;
				}
			}
			else
			{
                // ログインしないでキニッタ！を使用
                noLogin();
			}
		}
	}
}

/**
 * 初期ページをセットする（android, iOS用）
 */
async function setStartPage()
{
    if ( GFunc.isDebugEnabled() ) {console.log("setStartPage()");}
    let uid = 0;
    if ( GFunc.isLoggedin() ) { uid =  GFunc.getUi().uid.value; }
    const result: any = await Mst004.getMyFavorShops(GVar.sysCd, GVar.tmpltCd, uid);
    if ( result.values!.length == 0 )
    {
        // お気に入りになし
        if ( GFunc.isDebugEnabled() ) console.log("お気に入り店舗なし");
        GVar.setCurPage(GVar.topPage);      // 店舗検索ページ
    }
    else
    {
        // 既にお気に入りあり
        if ( GFunc.isDebugEnabled() ) console.log("お気に入り店舗あり="+result.values!.length);
        GVar.setCurPage("S05001006");  // お気に入りページ
    }
    if ( GFunc.isDebugEnabled() ) console.log("startPage="+GVar.curPage);
}

/**
 * ログインしないでキニッタ！を使用
 */
export async function noLogin()
{
	if ( GFunc.isDebugEnabled() ) {console.log("noLogin()");}

    // 通信用共通ヘッダーを作成
    JC.setCommonHeader(new JC.CommonHeader(0, "", GVar.langCd, GVar.countryCd, GVar.ttype, GVar.sysCd, GVar.tmpltCd));
    // 変数の初期化
    LVar.reInitLocalVars();
	newDay();
    // 接続情報登録
    await saveConnectInfo();
}

/**
 * ユーザー情報の読み込み（ログイン処理）
 * サーブレットとの通信が成功した場合、ユーザー情報(M109003JC)がJSON形式で返される。
 * ログイン可否の判断はsttsCdで行う。(0:ログイン済み,0以外：ログインエラー)
 * 
 * @parama email Emailアドレス
 * @param pwd パスワード
 * @param autoLogin 自動ログイン有無(true/false)
 * @param lang 画面表示用言語コード(ja,...)
 * @param ttype(A:Android, P:PC)
 * @return なし
*/
export const getUserInfo =
async function (eml: string, pwd: string, autoLogin: boolean, lang: string, ttype: string)
{
    if ( GFunc.isDebugEnabled() ) {console.log("getUserInfo()");}
	// ログイン処理
    const c000190JC = new JC.C000190JC();
    c000190JC.mpt003.cnctMtd = getProperty("CONNECT_METHOD.WEB")!; // 接続方式
    c000190JC.mpt003.sysCd = GVar.sysCd;        // システムコード
    c000190JC.mpt003.tmpltCd = GVar.tmpltCd;      // テンプレートコード
    c000190JC.mpt003.trmnlTyp = ttype;     // 接続端末
    c000190JC.eml = eml;                    // Eメール
    c000190JC.pwd = pwd;                    // パスワード
    c000190JC.langCd = lang;                // 言語コード
    // Waiting画像を表示(同期)
    GFunc.dispWating(getProperty("screen.common.label.pleaseWait")!);
    await axios.post(GVar.getServerUrl2()+"/c000190", 
        JSON.stringify(c000190JC),
        {headers: {"content-type": "application/json"}})
    .then(function (response) 
    {
        if ( GFunc.isDebugEnabled() ) { console.log(response); }
        const rtnUi = response.data;
        const ui = JSON.stringify(rtnUi);
        GFunc.setServerSttsCd(rtnUi.sttsCd);
         // ステータスチェック
         if ( rtnUi.sttsCd != getProperty("JSON.STATUS.OK") )
         {
            //
            // ログイン失敗
            //
            console.error("ログイン失敗 stts="+rtnUi.sttsCd+", msg="+rtnUi.msg);
            GFunc.setLoggedin(false);
            // エラーの内容でユーザー情報を保存する
            sessionStorage.setItem(GFunc.getUiKey(),ui);
            GFunc.setUi(rtnUi);
            GFunc.setServerMsg(decodeURI(rtnUi.msg));
         }
         else
         {
            //
            // ログイン完了
            //

            // 保存してある古いユーザー情報を全てクリアする
            GFunc.clearUserData();
            GFunc.setLoggedin(true);
            // ユーザー情報をsessionstorageに保存
            sessionStorage.setItem(GFunc.getUiKey(),ui);
            GFunc.setUi(rtnUi);
            GVar.setLangCd(rtnUi.lang);

            // ユーザー情報をDBに保存
            if ( Tools.isAndroid() || Tools.isIOS() )
            {
                let al = "0";   // オートログイン選定
                if ( autoLogin ) { al = "1"; }
                Mst002.saveLoginInfo(new Mst002.Mst002DTO(
                    GVar.sysCd,
                    GVar.tmpltCd,
                    eml,
                    pwd,
                    al,
                    Tools.getCurrentYyyymmddhhmmss())
                );
            }
            // ユーザー情報をJson用共通ヘッダーにセット
            JC.setCommonHeader(new JC.CommonHeader(rtnUi.uid.value, pwd, GVar.langCd, GVar.countryCd, ttype, GVar.sysCd, GVar.tmpltCd));
            GFunc.setServerMsg("");
            // カレント年月日を設定
            GFunc.setCurYYYYMMDD(Tools.getCurrentYyyymmdd());
         }
    })
    .catch(function (error) 
    {
        // ネットワークエラー
        GFunc.writeAxiosErrorLog(error);
        console.error("ネットワークエラー:"+GVar.getServerUrl2());
        GFunc.setServerSttsCd("");
        GFunc.setLoggedin(false);
        GFunc.setServerMsg(getProperty("msg.1001")
        +"["+GVar.getServerUrl2()+"], "
        +"["+error.response.data+"], "
        +"["+error.response.status+"], "      // 例：400
        +"["+error.response.statusText+"], "  // Bad Request
        +"["+error.response.headers+"]"
        );

    })
    .finally(function () {
        // Waiting画像を消す
        GFunc.removeWaiting();
    })
    ;
}

/**
 * ログイン後、トップページを開く前に行う処理（トップページを決定する）
 */
export async function afterLogin()
{
    if ( GFunc.isDebugEnabled() ) {console.log("afterLogin()");}
    // push通知初期化
    if ( Tools.isAndroid() || Tools.isIOS() )
    {
        // Android, iOS共通処理
        // push通知準備
        await Push.initializePushNotification();
    }
    else
    {
        // PC用処理
        // push通知準備
        await Push2.initializePushNotification();
    }
    // 変数の初期化
    LVar.reInitLocalVars();
    GVar.setRegisteredEmail("");
    newDay();
    // プロフィールを取得する
    await getProfile();
    // メンバー登録している店舗を取得する
    await getMemberShopList();
    // ダイナミックリンク起動の場合は初期ページの設定はここでは行わない。
    // ここで初期ページを設定するとダイナミックリンクでページ表示後に初期ページが表示されてしまう。
    if ( GVar.runMode == "2" ){return;}
    if ( LVar.c050010Keep != null && LVar.c050010Keep.results != null )
    {
        // メンバー登録している店舗があるのでマイページを返す
        GVar.setCurPage("S05001012");
        // 初期ページがマイページの時には、店舗リストは既にロード済みなのでロードしない
        LVar.setS05001012_loaded(true);
    }
    else
    {
        // メンバー登録している店舗がないので飲食店検索ページを返す
        GVar.setCurPage(GVar.topPage);
    }
    // 初期画面表示
    // 初期表示がトップページの場合はRouterで自動的に遷移するのでここでは指定しない
    if ( GVar.curPage != GVar.topPage )
    {   
        router.replace({name:GVar.curPage}); 
    }
}

/**
 * プロフィールを取得してグローバル変数に保存する
 */
async function getProfile()
{
    // パラメーターセット
    JC.commonHeader.actionFlag = GFunc.getProperty("C000070.actionFlag.R")!;
    const c000070JC = new JC.C000070JC();
    const mpt001 = new JC.Mpt001();
    c000070JC.mpt001 = mpt001;
    mpt001.uid = GFunc.getUi().uid.value; // ユーザーID
    // 取得処理を呼び出す
    await axios.post(GVar.getServerUrl2()+"/c000070", 
        JC.toJson(c000070JC),
        {headers: {"content-type": "application/json"}})
    .then(function (response) 
    {
        if ( GFunc.isDebugEnabled() ) { console.log(response); }
        const rtn = response.data;
        // ステータスチェック
        if ( rtn.sttsCd == GFunc.getProperty("JSON.STATUS.OK") )
        {
            // 結果を保存
            GVar.setC000070Keep(rtn);
        }
       else
        {
            // エラー
            alert(rtn.msg);
            return;
        }
    })
    .catch(function (error) 
    {
        // ネットワークエラー
        GFunc.writeAxiosErrorLog(error);
        alert(GFunc.getProperty("msg.1001"));
    });
} 

//=================================================================
// プロパティー用スクリプト
//=================================================================

/**
 * プロパティーの値を返す
 * 
 * @param key キー
 * @param 置換文字列(可変パラメーター)
 * @returns 値
 */
export function getProperty (key: string, ...reps: string[])
{
    let str = null;
    // メモった！、キニッタ！共通プロパティーを検索
    if ( null == (str = GFunc.getProperty(key)) )
    {
        // 見つからなければキニッタ！用Constを検索
        if ( null == (str = Const05.map.get(key)) )
        {
            // 見つからなければキニッタ！用メッセージを検索
            str = Msg05Ja.map.get(key);
        }
        if ( str != null )
        {
            // メッセージの場合、文字列の置き換えを行う
            reps.forEach( function(item, index)
            {
                str = eval("str.replace(/\\{\\$"+(index+1)+"\\}/g, item)");
            });
        }
    }
    return str;
}

//=================================================================
// ページ制御用スクリプト
//=================================================================

/**
 * ログアウト処理
 */
export function logout()
{
    console.debug("logout()");
    GFunc.setLoggedin(false);
    // local storageからパスワードを削除する
    const ui = GFunc.getUi();
    if ( !(typeof ui === "undefined") && ui != null )
    {
        // ユーザー情報をクリア
        ui.pwd = "";
        GFunc.clearUserData();
        // GFunc.setUi(ui);
        GVar.setLangCd(ui.lang);
    }
    // オートログインをオフにする
    if ( GVar.mst002 != null )
    {
        GVar.mst002.auto_login = "0";
        GVar.mst002.upd_ts = Tools.getCurrentYyyymmddhhmmss();
        Mst002.saveLoginInfo(GVar.mst002);
    }
    // 変数を初期化する
    LVar.reInitLocalVars();
    // ログイン画面へ遷移する
    router.replace({name:'S05001000'});
}

//=================================================================
// チェック用スクリプト
//=================================================================

// 日付大小チェック ymd1 <= ymd2
// 引数ymd1, ymd2はYYYY/MM/DD形式
export function isValidYmdRange(ymd1: string, ymd2: string)
{
	if (ymd1.replace(/\//g,"" ) > ymd2.replace(/\//g,"" ))
	{
		return false;
	}
	return true;
}

//=================================================================
// 地図用スクリプト
//=================================================================

/**
 * 地図表示用住所を編集して返す
 * @param mpt151 店舗情報
 */
export function getMapAddr(mpt151: any)
{
    if ( GFunc.isDebugEnabled() ) {console.log("getMapAddr()");}
    let addr = "";
    if ( mpt151.shpPstCd != null ) // 郵便番号
    {
        addr = mpt151.shpPstCd;
    }
    if ( addr != "" ) { addr += " ";}
    if ( mpt151.shpAddr != null ) // 住所
    {
        addr += mpt151.shpAddr;
    }
    return addr;
}

/**
 * 地図に表示されるポップアップの内容を編集して返す
 * @param mpt151 店舗情報
 */
export function getMapDesc(mpt151: any)
{
    if ( GFunc.isDebugEnabled() ) {console.log("getMapDesc()");}
    let desc = "";
    if ( mpt151.shpPstCd != null ) // 郵便番号
    {
        desc = "<div style='text-align: left;'><span class='map_shopInfo'>"+mpt151.shpPstCd+"</span></div>";
    }
    if ( mpt151.shpAddr != null ) // 住所
    {
        desc += "<div style='text-align: left;'><span class='map_shopInfo'>"+mpt151.shpAddr+"</span></div>";
    }
    if ( desc != "" )
    {
        // 説明を組み立てる
        desc = "<div style='text-align: center;'><span class='map_shopName'>"+mpt151.shpNm+"</span></div>"  // 店舗名
                 + desc;                // 住所
        if ( mpt151.shpPhnNo != null ) // 電話番号
        {
            desc += "<div style='text-align: left;'><span class='map_shopInfo'>"+mpt151.shpPhnNo+"</span></div>";
        }
        desc += "</div>";
    }
    return desc;
}

//=================================================================
// その他
//=================================================================

/**
 * 接続情報登録
 * サーバー側で接続可否を判断する
 *
 * @return true - 接続OK、 false - 接続NG
 */
export async function saveConnectInfo()
{
    if ( GFunc.isDebugEnabled() ) {console.debug("saveConnectInfo()");}
    // let stts = false;
    // パラメーターセット
    const c000190JC = new JC.C000190JC();
    c000190JC.mpt003.cnctMtd = getProperty("CONNECT_METHOD.WEB")!; // 接続方式
    c000190JC.mpt003.sysCd = GVar.sysCd;            // システムコード
    c000190JC.mpt003.tmpltCd = GVar.tmpltCd;        // テンプレートコード
    c000190JC.mpt003.trmnlTyp = GVar.ttype;         // 接続端末
    await axios.post(GVar.getServerUrl2()+"/c000190", 
        JSON.stringify(c000190JC),
        {headers: {"content-type": "application/json"}})
    .then(function (response) 
    {
        if ( GFunc.isDebugEnabled() ) { console.log(response); }
        const rtn = response.data;
        // ステータスチェック
        if ( rtn.sttsCd != getProperty("JSON.STATUS.OK") )
        {
            // stts = true;
            alert(rtn.msg); // エラー
        }
    })
    .catch(function (error) 
    {
        // ネットワークエラー
        GFunc.writeAxiosErrorLog(error);
        console.error("ネットワークエラー:"+GVar.getServerUrl2());
        alert(GFunc.getProperty("msg.1001"));
        router.push({name:'S05001000'});
    })
}

/**
 * 感染対策達成度を表示用の達成度に変換する
 * @param scr 感染対策達成度
 * @return 表示用達成度
 */
export function convAchivementScore(scr: number)
{
        let achievementScr = "0.0";
        if ( scr == null ) { return(achievementScr); }
        if ( scr > 4.5 ){ achievementScr = "5.0"; }
        else if ( scr > 4.0 ){ achievementScr = "4.5"; }
        else if ( scr > 3.5 ){ achievementScr = "4.0"; }
        else if ( scr > 3.0 ){ achievementScr = "3.5"; }
        else if ( scr > 2.5 ){ achievementScr = "3.0"; }
        else if ( scr > 2.0 ){ achievementScr = "2.5"; }
        else if ( scr > 1.5 ){ achievementScr = "2.0"; }
        else if ( scr > 1.0 ){ achievementScr = "1.5"; }
        else if ( scr > 0.5 ){ achievementScr = "1.0"; }
        else if ( scr > 0.1 ){ achievementScr = "0.5"; }
        return(achievementScr);
}

/**
 * ログインユーザーが店舗所有者又は管理者かを返す
 * @return true - 店舗所有者又は管理者、false - 店舗所有者又は管理者以外
 */
// export function hasShops()
// {
//     if ( GFunc.isDebugEnabled() ) {console.debug("hasShops()");}
//     if ( LVar.c050070Keep.results != null && LVar.c050070Keep.results.length > 0 )
//     {
//         return true;
//     }
//     else { return false; }
// }

/**
 * 現在選択中の店舗（プロジェクト）がプロジェクト有料オプションを持っているか確認する
 * この関数を呼ぶ前に必ずサーブレットc050070が呼ばれている事
 *
 * @param optCd オプションコード
 * @return ture - 保持している、 false - 保持してない
 */
export function hasOption(optCd: string)
{
    if ( LVar.c050010Keep == null || LVar.c050010Keep.results == null || LVar.c050010KeepIdx == null ) { return false; }
    if ( LVar.c050010Keep.results[LVar.c050010KeepIdx].options.includes(optCd) ) { return true; }
    else { return false; }
}

/**
 * メンバー登録している店舗の一覧を取得する
 */
export async function getMemberShopList()
{
    if ( GFunc.isDebugEnabled() ) {console.debug("getMemberShopList()");}
    // パラメーターセット
    JC.commonHeader.actionFlag = "R";
    const c050010JC = new JC.C050010JC();
    c050010JC.sysCd = GVar.sysCd;        // システムコード
    c050010JC.tmpltCd = GVar.tmpltCd;    // テンプレートコード
    // 会員登録済み店舗の検索
    c050010JC.includeMembers = true;
    await axios.post(GVar.getServerUrl2()+"/c050010", 
        JC.toJson(c050010JC),
        {headers: {"content-type": "application/json"}})
        .then(function (response) 
        {
            if ( GFunc.isDebugEnabled() ) { console.log(response); }
            const rtn = response.data;
            // ステータスチェック
            if ( rtn.sttsCd == getProperty("JSON.STATUS.OK") )
            {
                // 結果を保存する
                LVar.setC050010Keep(rtn);
            }
            else
            {
                // エラー
                alert(rtn.msg);
            }
        })
        .catch(function (error) 
        {
            // ネットワークエラー
            GFunc.writeAxiosErrorLog(error);
            alert(getProperty("msg.1001"));
        });
}

/**
 * 特定店舗情報を取得する
 *
 * @param shpId 店舗ID
 */
export async function getShop(shpId: any)
{
    if ( GFunc.isDebugEnabled() ) {console.debug("getShop()");}
    // パラメーターセット
    JC.commonHeader.actionFlag = "R";
    const c050010JC = new JC.C050010JC();
    c050010JC.sysCd = GVar.sysCd;        // システムコード
    c050010JC.tmpltCd = GVar.tmpltCd;    // テンプレートコード
    c050010JC.addShpId(shpId);      // 店舗ID
    await axios.post(GVar.getServerUrl2()+"/c050010",
        JC.toJson(c050010JC),
        {headers: {"content-type": "application/json"}})
        .then( response =>
        {
            if ( GFunc.isDebugEnabled() ) { console.log(response); }
            const rtn = response.data;
            LVar.setC050010Keep(rtn);
        })
        .catch(err =>
        {
          // ネットワークエラー
          alert(getProperty("msg.1001")+":"+err);
        })
        ;
}

/**
 * 特定店舗情報を取得する（一般利用モード用）
 *
 * @param evntNo イベントNo.
 */
export async function getShopByEventNo(evntNo: any)
{
    if ( GFunc.isDebugEnabled() ) {console.debug("getShopByEventNo() evntNo="+evntNo);}
    // パラメーターセット
    JC.commonHeader.actionFlag = "R";
    const c050080JC = new JC.C050080JC();
    c050080JC.sysCd = GVar.sysCd;        // システムコード
    c050080JC.tmpltCd = GVar.tmpltCd;    // テンプレートコード
    c050080JC.evntNo = evntNo;      // イベントNo.  
    // Waiting画像を表示
    await axios.post(GVar.getServerUrl2()+"/c050080", 
    JC.toJson(c050080JC),
    {headers: {"content-type": "application/json"}})
    .then(function (response) 
    {
        if ( GFunc.isDebugEnabled() ) { console.log(response); }
        const rtn = response.data;
        // ステータスチェック
        if ( rtn.sttsCd == getProperty("JSON.STATUS.OK") )
        {
            // 結果を退避
            LVar.setC050010Keep(rtn);
        }
        else
        {
            // エラー
            alert(rtn.msg);
        }
    })
    .catch(function (error) 
    {
        // ネットワークエラー
        GFunc.writeAxiosErrorLog(error);
        alert(GFunc.getProperty("msg.1001"));
    })
    ;
}

/**
 * 日付が変わった際の処理
 */
export function newDay()
{
    if ( GFunc.isDebugEnabled() ) {console.debug("newDay()");}
    //  現在の日付を取得する
    const currentDate = new Date();
    // 同一日付で既にnewDayが実行されている場合は全てスキップする
    if ( GVar.minYYYYMM != "" && GVar.maxYYYYMM != "" && GVar.today != null && Tools.getYyyymmddFromDate(GVar.today) == Tools.getYyyymmddFromDate(currentDate) ) {return;}
	// 年月選択リスト作成
	// ユーザーオプションにより年月リストの範囲を決定する
    GVar.setToday(currentDate);
	// 開始、終了年月日を設定する
    const beginDate = new Date(currentDate);
    beginDate.setMonth(beginDate.getMonth()+Number(getProperty('s05001102.cal.months.past'))*-1); // 開始年月日
    GVar.setBeginDate(beginDate);
    const endDate = new Date(currentDate);
    endDate.setMonth(endDate.getMonth()+Number(getProperty('s05001102.cal.months.future'))); // 終了年月日
    GVar.setEndDate(endDate);
	// 最小、最大年月の設定
	GVar.setMinYYYYMM(Tools.getYyyymmFromDate(beginDate));
	GVar.setMaxYYYYMM(Tools.getYyyymmFromDate(endDate));
}

/**
 * 店舗情報を表示用に編集する
 * 表示項目：店舗名、説明、ロゴ、写真、アクセス、住所、電話番号
 * @param mpt151 店舗情報
 */
export function composeShopInfo1(mpt151: any)
{
    let shpInfo = "";    // 店舗情報
    let shpNm = "";      // 店舗名
    let prjDesc = "";    // 説明
    let logoUrl = "";    // 店舗ロゴ用
    let photoUrl = "";   // 店舗写真用
    if ( mpt151.cntrctSttsCd == getProperty("shop.stts.cd.shop.approved") )
    {
        // 本登録
        shpNm = mpt151.shpNm; // 店舗名
        prjDesc = "";
        // 店舗説明
        const descs = JC.getMpt155Vals(mpt151, getProperty("mpt151.shpInfRecTyp.desc")!);
        if ( descs.length > 0 )
        {
            // 店舗説明は複数存在しないので先頭のオブジェクトを無条件に使う
            prjDesc = descs[0];
        }
        // ロゴ画像用html組み立て
        if ( mpt151.shpLg != null && mpt151.shpLg != "" )
        {
            // 画像あり
            logoUrl = "data:image/png;base64,"+mpt151.shpLg;
        }
        // 写真画像用html組み立て
        if ( mpt151.shpPht != null && mpt151.shpPht != "" )
        {
            // 画像あり
            photoUrl = "data:image/png;base64,"+mpt151.shpPht;
        }
    }
    else
    {
        // 仮登録中
        shpNm = mpt151.shpNm;   // 店舗名
        prjDesc = "";  // 説明
        logoUrl = "";  // ロゴ
        photoUrl = "";  // 写真
    }
    if ( logoUrl != "" )
    {
        // 1行目（ロゴあり）
        shpInfo += '<tr><td>'
                + '<table><tr><td rowspan="2" class="logoImgTd"><img src="'+logoUrl+'" class="logoImg"></td>'  // 店舗ロゴ
                +'<td class="grpnameTd"><span class="shopName">'+shpNm+'</span></td></tr>';        // 店舗名
        // 2行目
        shpInfo += '<tr><td style="text-align: left;"><span style="white-space: pre-wrap;">'+prjDesc+'</span></td></tr></table>';   // グループ説明
    }
    else
    {
        // 1行目（ロゴなし）
        shpInfo += '<tr><td class="grpnameTd"><span class="shopName">'+shpNm+'</span></td></tr>';        // 店舗名
        // 2行目
        shpInfo += '<tr><td style="text-align: left;"><span style="white-space: pre-wrap;">'+prjDesc+'</span></td></tr>';   // グループ説明
    }
    // 3行目
    if ( photoUrl != "" )
    {
        shpInfo += '<tr><td class="photoImgTd"><img src="'+photoUrl+'" class="photoImg"></td></tr>';   // グループ写真
    }
    // 4行目
    let shpAcs = "アクセス：";
    if ( mpt151.shpAcs != null ) { shpAcs+= mpt151.shpAcs; }
    shpInfo += '<tr><td class="detail"><span>'+shpAcs+'</span></td></tr>'; // アクセス
    // 5行目
    let shpAddr = "住所：";
    if ( mpt151.shpPstCd != null ) { shpAddr+= "〒"+mpt151.shpPstCd+" "; } // 郵便番号
    if ( mpt151.shpAddr != null ) { shpAddr+= mpt151.shpAddr; } // 住所
    shpInfo += '<tr><td class="detail"><span>'+shpAddr+'</span></td></tr>';
    // 6行目
    let shpPhnNo = "電話番号：";
    if ( mpt151.shpPhnNo != null ) { shpPhnNo+= mpt151.shpPhnNo; }
    shpInfo += '<tr><td class="detail"><span>'+shpPhnNo+'</span></td></tr>'; // 電話番号

    return(shpInfo);
}

/**
 * 店舗情報を表示用に編集する
 * 表示項目：店舗名、ロゴ
 * @param mpt151 店舗情報
 */
export function composeShopInfo2(mpt151: any)
{
    let shpInfo = "";    // 店舗情報
    let shpNm = "";      // 店舗名
    let logoUrl = "";    // 店舗ロゴ用
    if ( mpt151.cntrctSttsCd == getProperty("shop.stts.cd.shop.approved") )
    {
        // 本登録
        shpNm = mpt151.shpNm; // 店舗名
        // prjDesc = "";
        // ロゴ画像用html組み立て
        if ( mpt151.shpLg != null && mpt151.shpLg != "" )
        {
            // 画像あり
            logoUrl = "data:image/png;base64,"+mpt151.shpLg;
        }
    }
    else
    {
        // 仮登録中
        shpNm = mpt151.shpNm;   // 店舗名
        logoUrl = "";  // ロゴ
    }
    if ( logoUrl != "" )
    {
        // 1行目（ロゴあり）
        shpInfo += '<tr><td>'
                + '<table><tr><td rowspan="2" class="logoImgTd"><img src="'+logoUrl+'" class="logoImg"></td>'  // 店舗ロゴ
                +'<td class="grpnameTd"><span class="shopName">'+shpNm+'</span></td></tr>';        // 店舗名
    }
    else
    {
        // 1行目（ロゴなし）
        shpInfo += '<tr><td class="grpnameTd"><span class="shopName">'+shpNm+'</span></td></tr>';        // 店舗名
    }
    return(shpInfo);
}

/**
 * お店ホームページへのURLを返す
 * @returns お店ホームページへのURL
 */
export function getShopHpUrl(shpId: any)
{
    return(GFunc.getProperty("dynamiclink.05001.02.homepage")!+GFunc.getProperty("dynamiclink.05001.02.param.shpid")+"="+ shpId);
}

/**
 * お店ホームページへのダイナミックリンクを返す
 * @returns お店ホームページへのダイナミックリンク
 */
export function getShopHpDl(shpId: any)
{
    return(
        // https://p05001.page.link/?link=
        GFunc.getProperty("dynamiclink.05001.02.1")!
        // https://www.esplanadeone.com/p05001/05/p/index.html?
        + GFunc.getProperty("dynamiclink.05001.02.2")
        // shpid
        + GFunc.getProperty("dynamiclink.05001.02.param.shpid") 
        + "="
        // 店舗ID
        + shpId
        // &apn=com.esplanadeone.p05001&isi=1583712947&ibi=com.esplanadeone.p05001
        + GFunc.getProperty("dynamiclink.05001.02.3")
    // 応援メッセージ
    );
}